import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal} from 'antd'
import TickersInput from 'Components/Builder/TickersInput'

@inject('store') @observer
class TickersModal extends Component {
  changeTickers = (tickers) => {
    this.props.store.stockFilter.single.changeAdditional(tickers)
  }
  removeError = (name) => {
    this.props.store.stockFilter.single.removeError(name)
  }
  handleOk = () => {
    this.props.store.stockFilter.single.loadTagsData()
    this.props.close()
  }
  render() {
    const {errors, additionalTickersNames} = this.props.store.stockFilter.single
    return(
      <Modal
        title='Select additional tickers'
        visible={this.props.visible}
        onOk={this.handleOk}
        onCancel={this.props.close}
      >
        <TickersInput
          name='additional'
          tickers={additionalTickersNames}
          changeHandler={this.changeTickers}
          errors={errors}
          removeError={this.removeError}
        />
      </Modal>
    )
  }
}

export default TickersModal
